export enum MaintenanceElementStatus { notSet = "notSet", checkOkay = "checkOkay",
checkNotOkay = "checkNotOkay", notRequired = "notRequired" }
export enum MaintenanceElementCategory { condition = "condition", function = "function" }

export class MaintenanceListElementEntry {
  public id?: string;
  public description!: string; // old attribute name
  public controlStatus!: MaintenanceElementStatus;
  public comment!: string;
  public category!: MaintenanceElementCategory;
  public maintenanceListElement!: string | any; // Reference to the MaintenanceListElement ID or populated object
  public order?: number; // Order/position in the list

  constructor(maintenanceListData: any) {
    this.id = maintenanceListData._id;
    Object.assign(this, maintenanceListData);

    if (maintenanceListData.id) {
      this.id = maintenanceListData.id;

    }
  }
}

